import React, { useEffect, useState } from 'react';
import ReportBackBtn from '../../common/ReportBackBtn/ReportBackBtn';
import ReportsHeader from '../../common/ReportsHeader/ReportsHeader';
import { ReactComponent as promotionsIcon } from '../../assets/images/icons/promotions-icon.svg';
import PromotionCard from '../../components/PromotionsCard/PromotionCard';
import './Promotions.scss';
import { BRAND_DOMAIN } from '../../constants/Branding';
import SVLS_API from '../../api-services/svls-api';
import { AxiosResponse } from 'axios';
import Modal from '../../components/Modal/Modal';
import { BannerObjData, BannerResData, RenderHtml } from './Promotions.utils';
import { connect, useDispatch } from 'react-redux';
import { setAlertMsg } from '../../store/common/commonActions';
import { RootState } from '../../models/RootState';

const Promotions: React.FC<{ langData: any }> = (props) => {
  const { langData } = props;
  const dispatch = useDispatch();
  const [promotionBanners, setPromotionBanners] = useState<BannerObjData[]>([]);
  const [showKnowMoreModal, setShowMoreModal] = useState(false);
  const [promotionDisplayData, setPromotionDisplayData] = useState('');

  const handleKnowMoreClick = (bannerInfo: BannerObjData) => {
    const promotionDisplayContent = bannerInfo.displayContent;

    if (promotionDisplayContent) {
      setPromotionDisplayData(promotionDisplayContent);
      setShowMoreModal(true);
    } else {
      dispatch(
        setAlertMsg({
          type: 'error',
          message: langData?.['no_display_content_txt'],
        })
      );
    }
  };

  const getPromotionBanners = async () => {
    const bannersRes: AxiosResponse<BannerResData> = await SVLS_API.get(
      `/account/v2/books/${BRAND_DOMAIN}/banners`,
      {
        params: {
          category: 'Recommendedbanner',
          status: 'active',
          type: 'desktop',
        },
      }
    );

    setPromotionBanners(bannersRes.data.banners);
  };

  useEffect(() => {
    getPromotionBanners();
  }, []);

  return (
    <div className="promotions-page">
      <ReportBackBtn back={langData?.['back']} />
      <div>
        <ReportsHeader
          titleIcon={promotionsIcon}
          reportName={langData?.['promotions']}
          reportFilters={[]}
        />
      </div>
      <div className="promotion-card-ctn">
        {promotionBanners.length > 0 &&
          promotionBanners?.map((banner) => (
            <>
              <PromotionCard
                bannerData={banner}
                onKnowMorePress={handleKnowMoreClick}
                langData={langData}
              />
            </>
          ))}
      </div>

      <Modal
        open={showKnowMoreModal}
        closeHandler={() => setShowMoreModal(false)}
        title={langData?.['promotion_info']}
        size="xs"
        disableFullScreen
      >
        <div className="promotions-modal-ctn">
          <RenderHtml htmlString={promotionDisplayData} />
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    langData: state.common.langData,
  };
};

export default connect(mapStateToProps, null)(Promotions);
